import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { L } from 'harmony-language';
import { useSnackbar } from '../../../../components/notifications/use-snackbar';
import { Load } from '../../../../types';
import { useDraftsKey, useLoadsKey } from '../../../config-hooks';

interface AddLoadVariables {
    load: Load;
}

export const useAddLoadMutation = (isDrafts: boolean) => {
    const snackbar = useSnackbar();
    const queryKey = isDrafts ? useDraftsKey() : useLoadsKey();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (variables: AddLoadVariables) => {
            const load = {
                ...variables.load,
                date: variables.load.stops[0].arrivalTime || variables.load.date,
            }

            return (await axios.post(`${API_BASE}/api/orders`, load)).data;
        },
        // do not mutate on add as we need the load id for selection/expanded state
        // onMutate: () => {},
        onSuccess: (data) => {
            // map organizationId to owningOrganizationId as web project only knows organizationId
            data.organizationId = data.owningOrganizationId;
            const previousCache = queryClient.getQueryData<Load[]>(queryKey);

            if (previousCache) {
                const newLoads = previousCache.concat(data);
                queryClient.setQueryData<Load[]>(queryKey, newLoads);

                snackbar(isDrafts ? L.draftAddedSuccessfully() : L.loadAddedSuccessfully());
            }
        },
        // onSettled: () => {
        //     queryClient.invalidateQueries(queryKey);
        // },
    });

    return mutation;
};
